import { render, staticRenderFns } from "./stationFlow.vue?vue&type=template&id=a1253244&scoped=true"
import script from "./stationFlow.vue?vue&type=script&lang=js"
export * from "./stationFlow.vue?vue&type=script&lang=js"
import style0 from "./stationFlow.vue?vue&type=style&index=0&id=a1253244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1253244",
  null
  
)

export default component.exports